import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import isEmpty from 'lodash/isEmpty';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import { createProductReviewsQuery } from 'Redux/ducks/user-review';
import getUrlParameter from 'Helpers/Url/GetUrlParameter';

import 'Components/ProductReviews/UserReviews/UserRatingsBreakdown.scss';

const showRatingFilterLinks = false;

const UserRatingsBreakdown = ({
  userReviewRatingScoreBreakdown,
  mobileLayout,
  type,
  slug,
}) => {
  if (isEmpty(userReviewRatingScoreBreakdown)) return false;

  const sort = getUrlParameter('sort') || '';

  const ratingsBreakdown = [
    {
      name: 'one',
      number: 1,
      percent: userReviewRatingScoreBreakdown.one_star_percentage,
    },
    {
      name: 'two',
      number: 2,
      percent: userReviewRatingScoreBreakdown.two_star_percentage,
    },
    {
      name: 'three',
      number: 3,
      percent: userReviewRatingScoreBreakdown.three_star_percentage,
    },
    {
      name: 'four',
      number: 4,
      percent: userReviewRatingScoreBreakdown.four_star_percentage,
    },
    {
      name: 'five',
      number: 5,
      percent: userReviewRatingScoreBreakdown.five_star_percentage,
    },
  ];

  const OptionalLink = (props) => {
    if (props.to) {
      return <Link {...props} />;
    }
    return props.children;
  };

  OptionalLink.propTypes = {
    to: PropTypes.shape({}),
    children: PropTypes.node.isRequired,
  };

  OptionalLink.defaultProps = {
    to: null,
  };

  return (
    <article className="user-ratings-breakdown-container">
      {!mobileLayout &&
        <h3 className="h5 section-title">
          <FormattedMessage
            id="userratingsbreakdown.userratingsbreakdown"
            defaultMessage="User Ratings Breakdown"
          />
        </h3>
      }
      {ratingsBreakdown.sort((a, b) => b.number - a.number).map(rating =>
        <div className={classNames('user-rating-breakdown-container', `${rating.name}-stars`, { 'mobile-layout': mobileLayout })} key={rating.number}>
          <OptionalLink to={showRatingFilterLinks && rating.percent ? { pathname: `/${type}/${slug}/reviews`, search: `?${createProductReviewsQuery(null, rating.number, sort)}` } : null} rel="nofollow">
            <div className="user-rating-breakdown-title">
              <div>
                <FormattedMessage
                  id="userratingsbreakdown.stars"
                  defaultMessage="{starCount} Stars"
                  values={{ starCount: rating.number }}
                />
              </div>
              <div>
                {Math.round(rating.percent)}%
              </div>
            </div>
            <div className="progress-mobile-titles-container">
              <div className="rating-mobile-title">
                <FormattedMessage
                  id="userratingsbreakdown.stars"
                  defaultMessage="{starCount} Stars"
                  values={{ starCount: rating.number }}
                />
              </div>
              <div className="progress-container">
                <div className="progress">
                  <div
                    className={`progress-bar ${rating.name}-star`}
                    role="progressbar"
                    style={{ width: `${rating.percent}%` }}
                    aria-valuenow={Math.round(rating.percent)}
                    aria-valuemin="0"
                    aria-valuemax="100"
                    aria-label="Rating percent"
                    title="Rating percent"
                  />
                </div>
              </div>
              <div className="percent-mobile-title">
                {Math.round(rating.percent)}%
              </div>
            </div>
          </OptionalLink>
        </div>,
      )}
    </article>
  );
};

UserRatingsBreakdown.propTypes = {
  userReviewRatingScoreBreakdown: PropTypes.shape({}),
  mobileLayout: PropTypes.bool,
  type: PropTypes.string,
  slug: PropTypes.string,
};

UserRatingsBreakdown.defaultProps = {
  userReviewRatingScoreBreakdown: {},
  mobileLayout: false,
  type: '',
  slug: '',
};

export default UserRatingsBreakdown;
